// extracted by mini-css-extract-plugin
module.exports = {"OrganisationCards":"styles_OrganisationCards__sBIVj"};